import type { UserTypes } from '@modules';
import { LoadersType } from '@modules/builders';

import { asyncActions } from './actions';

export type UserStateType = {
  loaders: LoadersType<typeof asyncActions>;
  errors: {
    data?: Record<string, string[]>;
    message?: string;
  };
  captcha?: string;
  isSkippedKYC: boolean;
  token?: string;
  sessionId?: string;
  editToken?: string;
  data?: UserTypes.GetUserDataResponse;
  KYC?: UserTypes.AccessKYCTokenResponse;
  send_marketing_material: boolean;
  referralCode?: string;
  isStrongPasswordModal?: boolean;
  isZHDisclaimer: boolean;
  isCountryModal?: boolean;
  isIntroModal?: boolean;
  otpKey?: string;
  otp?: {
    url: string;
    seed: string;
  };
};

export const initialState: UserStateType = {
  loaders: {},
  errors: {},
  isSkippedKYC: false,
  isZHDisclaimer: false,
  isStrongPasswordModal: false,
  send_marketing_material: false,
};

export default initialState;
